import React from 'react';
import PropTypes from 'prop-types';
import { NewSchedulesTabScheduleEdit } from '@bingads-webui-campaign-react/schedule-edit-create';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { ErrorMessages } from '@bingads-webui-react/validation';
import classNames from 'classnames';

import { ErrorMap } from './error-map';

/* eslint-disable */
import PreviewGrid from '@bingads-webui-campaign-legacy/conversion-tracking/upload-conversions/changes-view';
import PollerTask from '@bingads-webui-static-legacy/uet/view/uploadConversions/pollerTask';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
/* eslint-enable */

class RawOfflineConversionScheduleCreate extends React.Component {
  constructor(props) {
    super(props);
    const {
      deps,
      schedule,
      onSaveSchedule,
      onCancelEditSchedule,
    } = props;

    this.onSaveSchedule = onSaveSchedule;
    this.onCancelEditSchedule = onCancelEditSchedule;
    this.schedule = this.getScheduleFromTaskItem(schedule);
    this.deps = deps;

    this.state = {
      previewResults: {
        RowsProcessed: 0,
        TotalRows: 0,
        HasAcrossAllAccountsOfflineConversionGoal: false,
      },
      progressBar: null,
      previewResultsErrorIdentifier: null,
      previewResultsIdentifier: null,
      showPreviewGrid: false,
      previewUploadError: false,
    };
  }

  getScheduleFromTaskItem = (taskItem) => {
    if (!taskItem) {
      return {};
    }

    const schedule = {
      Name: taskItem.Name,
      Id: taskItem.Id,
      Cron: taskItem.Cron,
      TimeZoneId: taskItem.TimeZoneId,
      Protocol: taskItem.ScheduledUploadProtocol,
      Url: taskItem.ScheduledUploadUrl,
      Username: taskItem.ScheduledUploadUsername,
      Password: taskItem.ScheduledUploadPassword,
      ClearPassword: taskItem.ScheduledUploadClearPassword,
      State: taskItem.State,
    };
    return schedule;
  }

  addSchedule = (schedule) => {
    const { instrumentation } = this.props;

    const { currentEntity } = getEntityFromScope(this.props.scope);
    if (currentEntity == null || !currentEntity.TaskItems) {
      const scenario = instrumentation.createScenario({ scenarioName: 'offlineConversionScheduleCreateView' });
      scenario.createActivity('addSchedule').trace(`currentEntity.TaskItems is null error. scope: ${JSON.stringify(this.props.scope)},
      currentEntity: ${JSON.stringify(currentEntity)}`);
    }
    const { newI18n } = this.props.deps;

    let scheduleSavedPromise = null;
    let scheduleId = schedule.Id;
    // Create New Schedule
    if (!scheduleId) {
      const taskItem = {
        '@odata.type': '#Model.OfflineConversionUploadTaskItem',
        Name: `${schedule.Protocol}://${schedule.Url}`,
        Type: 'OfflineConversionUploadCommit',
        Cron: schedule.Cron,
        NotificationType: 'Always',
        NotificationMedium: 'Email',
        TimeZoneId: schedule.TimeZoneId,
        ParentTaskId: null,
        ScheduledUploadProtocol: schedule.Protocol,
        ScheduledUploadUrl: schedule.Url,
        ScheduledUploadUsername: schedule.Username,
        ScheduledUploadPassword: schedule.Password,
        ScheduledUploadClearPassword: schedule.ClearPassword,
      };

      scheduleSavedPromise = currentEntity.TaskItems.post(taskItem).fetch().then(({ Id }) => {
        scheduleId = Id;
      });
    } else {
      // Patch Edited Schedule
      const updateTaskParams = {
        '@odata.type': '#Model.OfflineConversionUploadTaskItem',
        Type: 'OfflineConversionUploadCommit',
        Id: schedule.Id,
        Name: schedule.Protocol + schedule.Url,
        Cron: schedule.Cron,
        State: schedule.State,
        TimeZoneId: schedule.TimeZoneId,
        ParentTaskId: null,
        ScheduledUploadProtocol: schedule.Protocol,
        ScheduledUploadUrl: schedule.Url,
        ScheduledUploadUsername: schedule.Username,
        ScheduledUploadPassword: schedule.Password,
        ScheduledUploadClearPassword: schedule.ClearPassword,
      };

      scheduleSavedPromise = currentEntity.TaskItems.update(scheduleId, updateTaskParams);
    }

    scheduleSavedPromise.then(() => {
      const taskItemPreview = {
        '@odata.type': '#Model.OfflineConversionUploadTaskItem',
        Name: 'Scheduled Upload Preview',
        Type: 'OfflineConversionUploadPreview',
        Cron: '',
        NotificationType: 'Always',
        NotificationMedium: 'Email',
        TimeZoneId: schedule.TimeZoneId,
        ParentTaskId: scheduleId,
        ScheduledUploadProtocol: schedule.Protocol,
        ScheduledUploadUrl: schedule.Url,
        ScheduledUploadUsername: schedule.Username,
        ScheduledUploadPassword: schedule.Password,
        ScheduledUploadClearPassword: schedule.ClearPassword,
      };

      currentEntity.TaskItems.post(taskItemPreview, { select: ['TaskItemExecutions'] }).fetch().then((postData) => {
        const taskExecutionId = postData.TaskItemExecutions[0].Id;

        // Make a task item executions call
        const pollerTask = new PollerTask({ statusText: newI18n.getString(_TL_('Processing your upload...')), completeText: newI18n.getString(_TL_('Process complete')), ExecutionId: taskExecutionId });
        pollerTask.on('done', (data) => {
          const previewResults = {
            RowsProcessed: data.RowsProcessed,
            TotalRows: data.TotalRows,
            HasAcrossAllAccountsOfflineConversionGoal: false,
          };
          if (previewResults.RowsProcessed !== previewResults.TotalRows) {
            this.setState({ previewResultsErrorIdentifier: data.OfflineConversionFiles[2].Identifier });
          }
          this.setState({ previewResults, previewResultsIdentifier: data.OfflineConversionFiles[0].Identifier, showPreviewGrid: true });
        });
        pollerTask.on('update', (RowsProcessed, TotalRows) => {
          const previewResults = {
            RowsProcessed,
            TotalRows,
            HasAcrossAllAccountsOfflineConversionGoal: false,
          };
          this.setState({ previewResults });
        });
        pollerTask.on('error', (err) => {
          const prefix = newI18n.getString(_TL_('Received an error while previewing results: '));
          let errorText = newI18n.getString(_TL_('The requested file could not be found on the server.'));
          try {
            const res = JSON.parse(err.log.responseText);
            const errorCode = res.Errors && res.Errors[0] && res.Errors[0].Code;
            errorText = newI18n.getString(ErrorMap[errorCode]) || errorText;
          } catch (e) {
            // Empty
          }

          this.setState({ previewUploadError: prefix + errorText });
        });
        pollerTask.run();
        this.setState({ progressBar: pollerTask.view.render(), serverError: null });
      });
    }).catch((e) => {
      let serverError = newI18n.getString(_TL_('An unexpected error happened'));
      if (e && e.responseJSON && e.responseJSON.value && e.responseJSON.value[0] && e.responseJSON.value[0].Code === 'TaskThrottlingLimitReached') {
        serverError = newI18n.getString(_TL_('You have reached the maximum number of offline conversion schedules. Please delete existing schedules before adding new ones.'));
      }
      this.setState({ serverError });
    });
  }

  render() {
    let previewContainer = null;
    const { i18n, newI18n } = this.deps;

    if (this.state.previewUploadError) {
      const alertHelper = new AlertHelper({ i18n });
      alertHelper.showError(this.state.previewUploadError);
      this.onSaveSchedule();
    } else if (this.state.progressBar) {
      const previewGridParams = {
        type: 'scheduled-preview',
        errorsIdentifier: this.state.previewResultsErrorIdentifier,
        resultsIdentifier: this.state.previewResultsIdentifier,
        data: this.state.previewResults,
        isNewUI: true,
      };
      const previewGridView = new PreviewGrid(previewGridParams);
      previewGridView.on('close', () => {
        this.setState({
          showPreviewGrid: false, progressBar: null, previewResultsErrorIdentifier: null, previewResultsIdentifier: null, previewUploadError: false,
        });
        this.onSaveSchedule();
      });

      previewContainer = (
        <div className="operation-area section">
          { this.state.progressBar && <h2 className="schedules-tab__header">{newI18n.getString(_TL_('Schedule saved'))}</h2> }
          { this.state.progressBar && <p>{newI18n.getString(_TL_('Here is a preview of the results based on the data currently available at your file URL.'))}</p>}

          { this.state.progressBar && <BackboneInstanceWrapper
            managed
            instance={this.state.progressBar}
          />}
          { this.state.showPreviewGrid && <BackboneInstanceWrapper
            managed
            instance={previewGridView.render()}
          />}
        </div>);
    }

    const scheduleEditViewStrings = {
      frequencyLabelText: i18n.getString('SchedulesTab_Frequency_Label'),
      frequencyHelpId: 'pop_BA_OfflineConv_Frequency',
      timeZoneLabelText: i18n.getString('TimeZone_Label'),
      timeZoneHelpId: 'pop_BA_OfflineConv_TimeZone',
      urlLabelText: newI18n.getString(_TL_('File URL')),
      urlHelpId: 'pop_BA_OfflineConv_URL',
      descriptionHelpId: 'help:app54762',
      urlInsecureProtocolWarning: i18n.getString('SchedulesTab_URL_InsecureProtocolWarning'),
      usernameLabelText: i18n.getString('SchedulesTab_Username_Label'),
      usernameHelpId: 'pop_BA_OfflineConv_Username',
      passwordLabelText: i18n.getString('SchedulesTab_Password_Label'),
      passwordHelpId: 'pop_BA_OfflineConv_Password',
    };

    return (
      <I18nContext.Provider value={this.deps.i18n}>
        {previewContainer}
        {!previewContainer && <NewSchedulesTabScheduleEdit
          deps={this.deps}
          schedule={this.schedule}
          onSaveSchedule={({ schedule }) => this.addSchedule(schedule)}
          onCancelEditSchedule={() => this.props.onCancelEditSchedule()}
          lastError={[]}
          i18nStrings={scheduleEditViewStrings}
        />}
        { this.state.serverError &&
        <div className={classNames('server-error', 'error-text')}>
          <ErrorMessages messages={[this.state.serverError]} />
        </div>
      }
      </I18nContext.Provider>
    );
  }
}

RawOfflineConversionScheduleCreate.propTypes = {
  deps: PropTypes.shape({
    newI18n: PropTypes.shape({}).isRequired,
  }).isRequired,
  schedule: PropTypes.shape({
  }).isRequired,
  onSaveSchedule: PropTypes.func.isRequired,
  onCancelEditSchedule: PropTypes.func.isRequired,
  scope: PropTypes.shape({}).isRequired,
  instrumentation: PropTypes.shape({
    logError: PropTypes.func.isRequired,
    logTrace: PropTypes.func.isRequired,
  }).isRequired,
};

export const OfflineConversionScheduleCreate = withInstrumentation(RawOfflineConversionScheduleCreate);
